import { Dispatch } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

interface Props {
  employeeId?: string
  ownerLegalEntityName?: string
  readonly?: boolean
  legalEntityIds?: string[]
  onEmployeeIdSelected: Dispatch<string | undefined>
  errors?: string[] | null
  showEmployeeLegalEntity: boolean
}

const OwnerField = ({
  employeeId,
  ownerLegalEntityName,
  readonly,
  legalEntityIds,
  onEmployeeIdSelected,
  errors,
  showEmployeeLegalEntity,
}: Props) => {
  const shouldShowEmployeeLegalEntity = !!(showEmployeeLegalEntity && ownerLegalEntityName)

  return (
    <Box gap="s4">
      <EmployeeSelectorV2
        label={i18n.t('expenses_v2.forms.fields.owner.label')}
        disabled={readonly}
        value={employeeId}
        error={errors && errors.length > 0 ? errors[0] : undefined}
        onChange={onEmployeeIdSelected}
        forcedFilters={{ legalEntityIds }}
        mandatory
      />
      {shouldShowEmployeeLegalEntity && (
        <Text.Normal color="grey700" size="200">
          {i18n.t('expenses_v2.forms.fields.owner.legal_entity', {
            legal_entity: ownerLegalEntityName,
          })}
        </Text.Normal>
      )}
    </Box>
  )
}

export default observer(OwnerField)
